import api from "./api";

// CREATE CONTACT LOG
export const createContactLog = async (data) => {
  try {
    const response = await api.post(
      "/contact-log-management/contact-logs",
      data
    );

    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to create contact log",
    };
  }
};

// FETCH CONTACT LOGS (paginated)
export const fetchContactLogs = async (page = 1, size = 10) => {
  try {
    const response = await api.get(
      `/contact-log-management/contact-logs?page=${page}&size=${size}`
    );

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch contact logs",
    };
  }
};

// UPDATE CONTACT LOG
export const updateContactLog = async (logId, data) => {
  try {
    const response = await api.put(
      `/contact-log-management/contact-logs/${logId}`,
      data
    );

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to update contact log",
    };
  }
};

// FETCH CONTACT LOGS FOR SPECIFIC USER
export const fetchUserContactLogs = async (userId) => {
  try {
    const response = await api.get(
      `/contact-log-management/contact-logs/${userId}`
    );

    if (response.status === 200) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error: "Unexpected response",
    };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch user contact logs",
    };
  }
};

// DELETE CONTACT LOG
export const deleteContactLog = async (logId) => {
  try {
    const response = await api.delete(
      `/contact-log-management/contact-logs/${logId}`
    );

    if (response.status === 200) {
      return { success: true };
    }

    return { success: false, error: "Unexpected response" };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to delete contact log",
    };
  }
};